var ResourcesFaqs = function(){

    'use strict';

    var $ = jQuery;    var instances = [];


    function onReady() {
        $('.module.resources-faqs').each(function () {
            instances.push(initInstance($(this)));
        });
    }
    


    function initInstance(view) {

        // Private properties
        // * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *

        var $view = view,
            id = $view.data('id');

        // Private methods
        // * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *

        // instance object
        var instance = {
            init: function () {
                $view.find('div.faq-title').on('click', showAnswer)
            }
        };

        instance.init();
        return instance;
    }

    function showAnswer() {
        var id = $(this).data('faq-id');
        $("#answer-"+id).slideToggle('fast', function(){
            if($("#answer-"+id).is(':visible')){
                $(".title-"+id).removeClass('closed');
                $(".title-"+id).addClass('opened');
            }else{
                $(".title-"+id).removeClass('opened');
                $(".title-"+id).addClass('closed');
            }
        });
    }



    // DOMContentLoaded
    $(onReady);

}

ResourcesFaqs();
